import axios from '@/utils/request'

export default {
  constantlyDataBoardHoursReport: data => axios({ url: '/api/report/boardHoursReport', method: 'POST', data })// 报表-实时数据
}